import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Lock } from 'lucide-react';
const PURCHASE_LINK_BASE = 'https://fegion.shop/cart/46152988197003:1';
const PURCHASE_LINK_COMBO = 'https://fegion.shop/cart/46188570607755:1';
export function UpsellSection() {
  return <section className="w-full flex flex-col font-sans" data-id="element-243">
      {/* BLOCK 1: Alert Banner */}
      <div className="bg-[#FFFBEB] border-y-4 border-yellow-400 py-6 px-4 text-center" data-id="element-244">
        <div className="max-w-4xl mx-auto" data-id="element-245">
          <h2 className="text-2xl md:text-3xl font-black text-red-600 mb-2 tracking-tight" data-id="element-246">
            ⚡ MOMENTO — ANTES DE CONFIRMAR TU COMPRA
          </h2>
          <p className="text-lg md:text-xl font-bold text-gray-800" data-id="element-247">
            Agregá esto a tu pack y completá el sistema en un solo paso.
          </p>
        </div>
      </div>

      {/* BLOCK 2: Tension / The Big Adjustment */}
      <div className="py-16 px-4 bg-[#FDF8F0]" data-id="element-248">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center gap-12" data-id="element-249">
          <div className="flex-1" data-id="element-250">
            <p className="text-lg md:text-xl text-gray-800 leading-relaxed font-medium" data-id="element-251">
              "Las 50 Pomadas te dan el remedio. Pero... ¿quién cuida la higiene
              y la base de tu curación? Preparás la mejor pomada de Árnica,
              tenés las plantas, los aceites y el saber de los abuelos. Y sin
              embargo...{' '}
              <strong className="text-[#2D5A27]" data-id="element-252">
                si la piel no está limpia con el grado terapéutico correcto, la
                pomada no penetra igual.
              </strong>
              "
            </p>
          </div>
          <div className="flex-1 flex justify-center w-full" data-id="element-253">
            <div className="relative w-64 h-64 mx-auto" data-id="element-254">
              <div className="absolute inset-0 bg-[#2D5A27] rounded-full opacity-10 blur-xl" data-id="element-255"></div>
              <div className="relative w-full h-full rounded-full border-4 border-[#2D5A27] bg-[#FFFBEB] flex flex-col items-center justify-center shadow-2xl overflow-hidden" data-id="element-256">
                <div className="text-6xl mb-3" data-id="element-257">🧼</div>
                <div className="text-3xl flex gap-3" data-id="element-258">🌿 🌼 🍃</div>
                <div className="mt-4 text-sm font-black text-[#2D5A27] uppercase tracking-widest border-t-2 border-[#2D5A27] pt-2" data-id="element-259">
                  Artesanal
                </div>
              </div>
              <div className="absolute -bottom-2 -right-2 text-4xl animate-bounce" style={{
              animationDuration: '3s'
            }} data-id="element-260">
                ✨
              </div>
              <div className="absolute top-4 -left-4 text-4xl" data-id="element-261">🌱</div>
            </div>
          </div>
        </div>
      </div>

      {/* BLOCK 3: Product Value Block */}
      <div className="py-16 px-4 bg-white" data-id="element-262">
        <div className="max-w-4xl mx-auto" data-id="element-263">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-[Georgia,serif] font-bold text-[#2D5A27] text-center mb-10 leading-tight" data-id="element-264">
            🏆 MEJORÁ TU PACK CON:
            <br data-id="element-265" />
            RECETARIO DE JABONES MEDICINALES
            <br data-id="element-266" />
            <span className="text-xl md:text-2xl text-gray-500 italic font-sans mt-2 block" data-id="element-267">
              (Grado Terapéutico y Ancestral)
            </span>
          </h2>

          <div className="bg-[#FDF8F0] rounded-2xl p-8 md:p-10 border border-[#2D5A27]/20 shadow-lg" data-id="element-268">
            <ul className="space-y-6 text-lg md:text-xl text-gray-800 max-w-3xl mx-auto" data-id="element-269">
              <li className="flex items-start gap-4" data-id="element-270">
                <span className="text-2xl flex-shrink-0 mt-1" data-id="element-271">🌿</span>
                <div data-id="element-272">
                  <strong className="text-[#2D5A27]" data-id="element-273">
                    Jabones Específicos:
                  </strong>{' '}
                  Recetas de Ortiga, Caléndula y Azufre.
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-274">
                <span className="text-2xl flex-shrink-0 mt-1" data-id="element-275">🌿</span>
                <div data-id="element-276">
                  <strong className="text-[#2D5A27]" data-id="element-277">Base Terapéutica:</strong>{' '}
                  Cómo crear jabones que mantienen las propiedades de las
                  plantas.
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-278">
                <span className="text-2xl flex-shrink-0 mt-1" data-id="element-279">🌿</span>
                <div data-id="element-280">
                  <strong className="text-[#2D5A27]" data-id="element-281">
                    Protocolo de Higiene:
                  </strong>{' '}
                  El orden exacto (Limpieza + Aplicación).
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-282">
                <span className="text-2xl flex-shrink-0 mt-1" data-id="element-283">🌿</span>
                <div data-id="element-284">
                  <strong className="text-[#2D5A27]" data-id="element-285">Sin Químicos:</strong>{' '}
                  Eliminá sulfatos que bloquean tus poros.
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* BLOCK 4: Plan Comparison Table - COMBO MAESTRO FIRST */}
      <div className="py-16 px-4 bg-[#FDF8F0]" data-id="element-286">
        <div className="max-w-5xl mx-auto" data-id="element-287">
          <div className="flex flex-col md:flex-row gap-8 items-stretch justify-center" data-id="element-288">
            {/* Combo Maestro - FIRST */}
            <div id="pack-completo" className="flex-1 bg-white rounded-2xl p-8 md:p-10 border-4 border-[#2D5A27] shadow-2xl flex flex-col relative transform md:-translate-y-4 z-10" data-id="element-289">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#2D5A27] text-white px-6 py-2 rounded-full font-black text-sm md:text-base whitespace-nowrap shadow-lg tracking-wide" data-id="element-290">
                ⭐ RECOMENDADO
              </div>
              <h3 className="text-2xl md:text-3xl font-black text-[#2D5A27] text-center mb-6 mt-2" data-id="element-291">
                PACK COMPLETO
              </h3>
              <div className="space-y-0 flex-1 flex flex-col" data-id="element-292">
                <div className="py-4 border-b border-green-100 text-gray-900 font-bold text-center text-lg" data-id="element-293">
                  Libro 50 Pomadas + 2 Bonos + Recetario Jabones
                </div>
                <div className="py-4 border-b border-green-100 text-[#2D5A27] font-black text-center" data-id="element-294">
                  Sistema Completo (Limpieza + Curación)
                </div>
                <div className="py-8 text-center flex-1 flex items-center justify-center" data-id="element-295">
                  <span className="text-4xl md:text-5xl font-black text-[#2D5A27]" data-id="element-296">
                    $14.990 ARS
                  </span>
                </div>
              </div>
              <CTAButton text="SÍ, QUIERO EL PACK COMPLETO" href={PURCHASE_LINK_COMBO} isExternal={true} className="mt-4 text-lg md:text-xl py-5" data-id="element-297" />
            </div>

            {/* Pack Base - SECOND */}
            <div className="flex-1 bg-white rounded-2xl p-6 md:p-8 border-2 border-gray-200 shadow-sm flex flex-col opacity-90 md:mt-6" data-id="element-298">
              <h3 className="text-xl font-black text-gray-500 text-center mb-6 tracking-wide" data-id="element-299">
                PACK BASE
              </h3>
              <div className="space-y-0 flex-1 flex flex-col" data-id="element-300">
                <div className="py-4 border-b border-gray-100 text-gray-600 text-center font-medium" data-id="element-301">
                  Las 50 Pomadas Medicinales + 2 Bonos
                </div>

                <div className="py-8 text-center flex-1 flex items-center justify-center" data-id="element-302">
                  <span className="text-3xl font-black text-gray-800" data-id="element-303">
                    $9.990 ARS
                  </span>
                </div>
              </div>
              <a href={PURCHASE_LINK_BASE} target="_blank" rel="noopener noreferrer" className="block w-full text-center py-3 px-4 rounded-xl border-2 border-gray-300 text-gray-500 font-bold hover:bg-gray-50 hover:text-gray-700 transition-colors mt-4 bg-[#E3D4D4]" data-id="element-304">
                Elegir PACK BASE
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* BLOCK 5: Urgency/Closing */}
      <div className="py-12 px-4 bg-white" data-id="element-305">
        <div className="max-w-3xl mx-auto bg-[#FFFBEB] border-l-8 border-[#2D5A27] p-6 md:p-8 rounded-r-2xl shadow-md" data-id="element-306">
          <p className="text-xl md:text-2xl font-medium text-gray-800 leading-relaxed" data-id="element-307">
            💡 <strong className="font-black" data-id="element-308">Solo $5.000 ARS más.</strong> El
            Recetario de Jabones por separado vale $9.990 ARS. Agregándolo
            ahora, lo llevás a{' '}
            <span className="text-[#2D5A27] font-black underline decoration-4 underline-offset-4" data-id="element-309">
              MITAD DE PRECIO
            </span>
            .
          </p>
        </div>
      </div>

      {/* BLOCK 6: Final CTA + Purchase Breakdown */}
      <div className="py-16 px-4 bg-[#FDF8F0] text-center" data-id="element-310">
        <div className="max-w-4xl mx-auto" data-id="element-311">
          <CTAButton text="PACK COMPLETO RECOMENDADO (50 Pomadas + Jabones) por $14.990 ARS" href={PURCHASE_LINK_COMBO} isExternal={true} className="text-xl md:text-2xl py-6 mb-6" data-id="element-312" />

          {/* "No gracias" as soft orange button */}
        </div>

        {/* Purchase Breakdown (moved from SECTION 10) */}
        <div id="compra" className="max-w-4xl mx-auto bg-green-50 rounded-3xl p-8 md:p-12 border-4 border-green-600 shadow-2xl relative" data-id="element-313">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-2 rounded-full font-black text-lg md:text-xl shadow-lg whitespace-nowrap" data-id="element-314">
            ⏰ Oferta disponible por tiempo limitado
          </div>

          <div className="mt-8 mb-10" data-id="element-315">
            <h2 className="text-2xl md:text-3xl font-black text-center mb-8 text-gray-900" data-id="element-316">
              Valor del Paquete Base
            </h2>
            <div className="space-y-4 max-w-xl mx-auto" data-id="element-317">
              <div className="flex justify-between items-center py-3 border-b border-green-200" data-id="element-318">
                <p className="font-bold text-gray-900 text-lg" data-id="element-319">
                  Libro: Las 50 Pomadas Medicinales
                </p>
                <p className="font-black text-gray-700 text-lg" data-id="element-320">$15.000</p>
              </div>
              <div className="flex justify-between items-center py-3 border-b border-green-200" data-id="element-321">
                <p className="font-bold text-gray-900 text-lg" data-id="element-322">
                  Bono 1: 100 Plantas Medicinales
                </p>
                <p className="font-black text-gray-700 text-lg" data-id="element-323">$10.000</p>
              </div>
              <div className="flex justify-between items-center py-3 border-b border-green-200" data-id="element-324">
                <p className="font-bold text-gray-900 text-lg" data-id="element-325">
                  Bono 2: Guía de Aceites Medicinales
                </p>
                <p className="font-black text-gray-700 text-lg" data-id="element-326">$8.000</p>
              </div>
              <div className="flex justify-between items-center pt-4 mt-2 border-t-2 border-gray-800" data-id="element-327">
                <p className="font-black text-gray-900 text-xl md:text-2xl" data-id="element-328">
                  Valor total:
                </p>
                <p className="font-black text-red-600 text-2xl md:text-3xl line-through" data-id="element-329">
                  $33.000
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mb-6" data-id="element-330">
            <p className="text-4xl md:text-5xl font-black text-green-600 mt-2" data-id="element-331">
              HOY SOLO: $9.990
            </p>
          </div>

          <CTAButton text="👉 SÍ, QUIERO MI LIBRO + BONOS AHORA" href={PURCHASE_LINK_BASE} isExternal={true} className="text-2xl md:text-3xl py-6" data-id="element-332" />
          <div className="text-center mt-4 mb-10 text-sm text-gray-600 font-medium flex items-center justify-center gap-1" data-id="element-333">
            <Lock className="w-4 h-4" data-id="element-334" /> Pago 100% Seguro
          </div>

          <div className="bg-white p-6 rounded-xl border border-gray-200 mb-6 text-center" data-id="element-335">
            <div className="flex justify-center mb-4" data-id="element-336">
              <ShieldCheck className="w-16 h-16 text-green-600" data-id="element-337" />
            </div>
            <h3 className="text-2xl font-black mb-2 flex items-center justify-center gap-2" data-id="element-338">
              <Lock className="w-6 h-6" data-id="element-339" /> Garantía de Satisfacción
            </h3>
            <p className="text-gray-700 font-medium mb-4" data-id="element-340">
              Si el contenido no cumple tus expectativas, simplemente puedes
              solicitar un reembolso dentro del período de garantía.
            </p>
            <p className="text-gray-900 font-bold" data-id="element-341">Tu compra es 100% segura.</p>
          </div>
        </div>
      </div>
    </section>;
}